// extracted by mini-css-extract-plugin
export default {"root":"yAqIfVLDSIt426FJwxhE","copy":"uRkgYMGYazo3U4F70orM","btn":"QD1dFrc8_brnnTTc71gy"};